import React from 'react';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";

import {fetchUserStatus, updateUserStatus} from "../../../../creators/user.status";

import InputPost from "../../InputPost";
import {PageLoader} from "../../Loader";

class EditStatus extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.props.fetchUserStatus(this.props.userId, this.props._id);
    }

    handleSubmit(content) {
        this.props.updateUserStatus(this.props.userId, this.props._id, content);
        this.props.handleClose();
    }

    render() {
        let isMe = this.props.currentUser && this.props.currentUser._id && this.props.author._id === this.props.currentUser._id;
        return !this.props.userStatusInitialized ? (
            <div className="edit-status">
                <div className="card publish-status">
                    <PageLoader/>
                </div>
            </div>
        ) : (
            <div className="edit-status">
                <div className="card publish-status">
                    <div className="text">
                        {isMe ? (
                            "Editer ce statut"
                        ) : (
                            `Editer le statut ${this.props.author.username || ""}`
                        )}
                    </div>
                    {this.props.userStatusLoading ? (
                        <PageLoader/>
                    ) : (
                        <InputPost sendBtn={true}
                                   editorStyle={"edit-comment--draft"}
                                   btnContent={"Editer le statut"}
                                   emoji={true}
                                   placeholder={`${this.props.currentUser.username}, écrivez ce que vous avez en tête ...`}
                                   handleSubmit={this.handleSubmit}
                                   loading={this.props.userStatusSubmitting}
                                   contentRaw={this.props.contentRaw}/>
                    )}
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        userStatus: state.userStatus.data,
        userStatusLoading: state.userStatus.loading,
        userStatusSubmitting: state.userStatus.submitting,
        userStatusInitialized: state.userStatus.initialized,

        currentUser: state.currentUser.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserStatus,
    updateUserStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditStatus);
